import logo from 'assets/header-prevencor-xx.png';
import AssinaturaEletronica from 'components/core/AssinaturaEletronica';
import LaudoActionButtons from 'components/laudos/LaudoActionButtons';
import { Card, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { selectTiltById } from 'services/tilt';
import useSWR from 'swr';
import { generatePDFTilt } from './generatePDFTilt';
import { parseTilt } from './helpers';
import TiltTestBarChart from './TiltTestBarChart';

function buildChartData(tiltText) {
  const dados = parseTilt(tiltText);
  if (!dados?.repouso || !dados?.inclinacao) return [];

  const repouso = dados.repouso;
  const inclinacao = dados.inclinacao;

  const valido =
    Number.isFinite(repouso.PAS) &&
    Number.isFinite(repouso.PAD) &&
    Number.isFinite(repouso.FC) &&
    Number.isFinite(inclinacao.PAS) &&
    Number.isFinite(inclinacao.PAD) &&
    Number.isFinite(inclinacao.FC);

  if (!valido) return [];

  return [
    {
      periodo: 'Repouso',
      PAS: repouso.PAS,
      PAD: repouso.PAD,
      FC: repouso.FC,
    },
    {
      periodo: 'Inclinação',
      PAS: inclinacao.PAS,
      PAD: inclinacao.PAD,
      FC: inclinacao.FC,
    },
  ];
}

export default function ReportTiltTest() {
  const { id } = useParams();
  const {
    data: tilt,
    isLoading,
    error,
  } = useSWR(id ? ['tilt', id] : null, () => selectTiltById(id));

  const ecoTilt = Array.isArray(tilt) ? tilt[0] : tilt || null;
  const textoLaudo = ecoTilt?.TILTTEST;
  const chartData = buildChartData(textoLaudo);

  return (
    <Card className="mb-2 mt-2">
      <Card.Header className="text-center font-weight-bold">
        <img
          src={logo}
          alt="Prevencor"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto 8px' }}
          className="no-print"
        />
        LAUDO DE TILT TEST
      </Card.Header>

      {isLoading && (
        <Card.Body>
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Card.Body>
      )}

      {error && !isLoading && (
        <Card.Body className="text-center text-danger py-5">
          {error.message || 'Erro ao carregar o laudo.'}
        </Card.Body>
      )}

      {!isLoading && !error && !ecoTilt && (
        <Card.Body className="text-muted text-center py-5">Laudo não encontrado.</Card.Body>
      )}

      {ecoTilt && !isLoading && !error && (
        <>
          <Card.Body>
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${ecoTilt.CODPAC || '--'} - ${ecoTilt.NOMEPAC || '--'}`}
            <br />
            <strong className="mr-auto">Data de Nasc: </strong>
            {ecoTilt.dataNasc || '--'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {ecoTilt.SEXOPAC || '--'}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {ecoTilt.idadePAC != null ? `${ecoTilt.idadePAC} anos` : '--'}
            <br />
            <strong className="mr-auto">Convênio: </strong>
            {ecoTilt.SIGLACONV || '--'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Código: </strong>
            {ecoTilt.CODTILT || ecoTilt.CODIGO || '--'}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {ecoTilt.dataTilt || '--'}
            <br />
            <strong className="mr-auto">Médico que Realizou: Dr. </strong>
            {ecoTilt.Realizou || '--'}
            <br />
            <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
            {ecoTilt.Solicitou || '--'}
            <hr />
            <div style={{ whiteSpace: 'pre-wrap' }}>{ecoTilt?.TILTTEST}</div>
            <hr />
            {chartData.length > 0 && <TiltTestBarChart chartData={chartData} />}
          </Card.Body>

          <Card.Footer className="text-center no-print">
            <LaudoActionButtons
              actions={[
                {
                  key: 'timbrado',
                  label: 'Timbrado',
                  onClick: () => generatePDFTilt({ tilt: ecoTilt }),
                },
              ]}
            />
          </Card.Footer>

          <Card.Footer className="text-center">
            <AssinaturaEletronica data={ecoTilt} nome={ecoTilt.Realizou} showPrintButton={false} />
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
